import { render, staticRenderFns } from "./LmDropdownTableCustom.vue?vue&type=template&id=88904b20&scoped=true&"
import script from "./LmDropdownTableCustom.vue?vue&type=script&lang=js&"
export * from "./LmDropdownTableCustom.vue?vue&type=script&lang=js&"
import style0 from "./LmDropdownTableCustom.vue?vue&type=style&index=0&id=88904b20&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88904b20",
  null
  
)

export default component.exports